import axios from 'axios';

import {notifsActions, loadingOverlayActions} from "../index";
import new_axios_instance from '../../axios_instance';
import {createMessageRequestException} from "../../fanctionUtility";

import * as types from '../actionsTypes/authenticationActionTypes';


axios.defaults.timeout = 100000;

export const initAuth = () => {
    return {
        type: types.INIT_AUTH
    }
};

export const clearError = () => {
    return {
        type: types.CLEAR_ERROR
    }
};


export const authenticationStart = (clientId, baseUrlAuthService, redirectUri, navigate) => async dispatch => {
    dispatch(loadingOverlayActions.showLoadingOverlay());
    dispatch(initAuth());
    window.location.assign(`${baseUrlAuthService}/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=profile`);
};

export const verificaRuoli = () => async dispatch => {
    dispatch(verificaRuoliAction())
    await new_axios_instance.get(`/v1/utenteanagrafica/ricerca/abilitazioni`)
        .then(response => {
            if (response.data.length !== 0) {
                if(response.data.length === 1) {
                    dispatch(salvaRuolo(response.data[0].nome));
                } else {
                    dispatch(salvaProfiliDisponibili(response.data));
                }
            } else {
                dispatch(salvaProfiliDisponibiliFail({message: 'utente non censito'}));
            }
        })
        .catch(error => {
    if (error.response && error.response.status === 403) {
        dispatch(salvaProfiliDisponibiliFail({message: 'Il tuo account è stato disabilitato. Contatta l\'amministratore di sistema.'}));
    } else {
        dispatch(salvaProfiliDisponibiliFail({message: error.message}));
    }
});
};

export const recuperaGeneralita = (baseUrlAuthService) => dispatch => {
    new_axios_instance.get(`${baseUrlAuthService}/userinfo`).then(response =>
        dispatch(recuperaGeneralitaAction(response.data))
    ).catch(error => {
        console.error(error)
    })
}

// export for testing
export const verificaRuoliAction = () => {
  return {
      type: types.VERIFICA_RUOLI_ACTION
  }
};

// export for testing
export const salvaProfiliDisponibili = (data) => {
    return {
        type: types.RECUPERA_PROFILI_SUCCESS,
        profiliDisponibili: data
    };
};

// export for testing
export const salvaProfiliDisponibiliFail = (error) => {
    return {
        type: types.RECUPERA_PROFILI_FAIL,
        error: error
    };
};

// export for testing
export const salvaRuolo = (ruolo) => {
    return {
        type: types.SALVA_RUOLO_SCELTO,
        ruolo: ruolo
    }
};

export const richiediToken = (clientId, baseUrlAuthService, code, redirectUri, navigate) => async dispatch => {
    const data = new URLSearchParams();
    data.append('grant_type', 'authorization_code');
    data.append('client_id', clientId);
    data.append('code', code);
    data.append('redirect_uri', redirectUri);

    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    };

    const response = await axios.post(
       `${baseUrlAuthService}/token`,
        data,
        { headers }
    );

    dispatch(getToken(response.data));
    navigate('/')
};

// export for testing
export const richiediTokenAction = () => {
    return {
        type: types.RICHIEDI_TOKEN_ACTION
    }
};

// export for testing
export const getToken = (token) => {
    return {
        type: types.GET_TOKEN,
        token: token
    }
};

export const recuperaGeneralitaAction = (user) => {
    return {
        type: types.RECUPERA_GENERALITA,
        user: user
    }
};

export const requestRefreshToken = (clientId, baseUrlAuthService, refreshToken, navigate) => async dispatch => {
    const data = new URLSearchParams();
    data.append('grant_type', 'refresh_token');
    data.append('client_id', clientId);
    data.append('refresh_token', refreshToken);

    dispatch(requestRefreshTokenAction());

    await axios.post(`${baseUrlAuthService}/token`, data)
        .then(response => {
            new_axios_instance.defaults.headers.common['Authorization'] = `${response.data.token_type} ${response.data.access_token}`;
            dispatch(getToken(response.data));
        }).catch(error => {
            const message = createMessageRequestException(error);

            dispatch(requestRefreshTokenFail());
            dispatch(initAuth());
            dispatch(notifsActions.notifError(message));
            sessionStorage.clear();
            navigate('/login');

        })
};

// export for testing
export const setTokenRefresch = (data) => {
    return {
        type: types.SET_TOKEN_REFRESH,
        tokenData: data
    }
};

// export for testing
export const requestRefreshTokenAction = () => {
    return {
        type: types.REQUEST_REFRESH_TOKEN_START
    }
};

// export for testing
export const requestRefreshTokenFail = () => {
    return {
        type: types.REQUEST_REFRESH_TOKEN_FAIL
    }
};